<div class="container">
  <div class="aboutus_text">
    <div id="html" class="vid-description footerdesc" [innerHTML]="linkContent | safeHtml: 'html'" ></div>
  </div>
</div>
